
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-media/podcasts",
      function () {
        return require("private-next-pages/news-media/podcasts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-media/podcasts"])
      });
    }
  